import { Typography } from 'antd';
import styled from 'styled-components';

import { DEVICE_SIZES } from '../../constants/common';

export const LandingTitle = styled(Typography.Title).attrs({ level: 1 })`
  && {
    font-size: 48px;
    line-height: 1.1;
    margin-bottom: 0;
    font-weight: 700 !important;
    padding-top: 24px;

    @media (max-width: ${DEVICE_SIZES.tablet}) {
      font-size: 22px;
      padding-top: 40px;
    }
  }
`;

export const LandingParagraph = styled(Typography.Paragraph)`
  && {
    font-size: 18px;
    margin: 24px 0;

    @media (max-width: ${DEVICE_SIZES.tablet}) {
      font-size: 16px;
      margin: 30px 0;
    }
  }
`;

export const LandingVideo = styled.video`
  width: 100%;
  object-fit: cover;
  display: block;
  border-radius: 16px;
`;
